<app-authorized-guard [authorized]="!unauthorized">
  <app-loading-guard [loading]="entityList.loading">
    <ng-container *ngIf="resolvedDefaultPlan as defaultPlan">
      <h2 class="default-plan-heading">You're almost set!</h2>
      <p class="default-plan-text">
        To activate your account, you'll be asked to add a credit card and
        finalize your
        <strong class="default-plan-title">{{
          defaultPlan.displayName
        }}</strong>
        subscription.
      </p>
      <button
        mat-flat-button
        color="primary"
        [disabled]="pending"
        (click)="handleDefaultPlanSubscribe()"
        class="default-plan-button"
      >
        Start
        <span class="default-plan-title">{{ defaultPlan.displayName }}</span>
        Subscription
      </button>
    </ng-container>

    <ng-container *ngIf="!resolvedDefaultPlan">
      <h2 class="plan-heading">Please select your plan</h2>
      <div class="plan-list">
        <mat-card
          *ngFor="let item of entityList.entities"
          class="plan-card"
          [class.active]="item.id === active"
        >
          <mat-card-header class="plan-header">
            <mat-card-title
              ><p class="plan-title">
                {{ item.metadata.title }}
              </p></mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <p class="plan-amount">
              <span class="plan-amount-value">{{
                formatAmount(item.amount, item.currency, 0)
              }}</span>
              {{ item.currency }}/{{ item.interval }}
            </p>
          </mat-card-content>
          <mat-divider class="divider plan-card-divider"></mat-divider>
          <mat-card-content
            class="plan-description"
            [class.pricing-expanded]="expandedPlanIds.has(item.id)"
            (click)="onDescriptionClick($event, item.id)"
          >
            <div [innerHTML]="item.metadata.description_html"></div>
          </mat-card-content>
          <mat-card-actions class="plan-actions">
            <button
              mat-flat-button
              [disabled]="pending || item.id === active"
              (click)="handlePlanClick(item)"
              class="plan-button"
            >
              {{ item.id === active ? 'Currently Subscribed' : 'Choose Plan' }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </ng-container>
  </app-loading-guard>
</app-authorized-guard>
